import { AuthData } from './../../models/authdata';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { DashboardService } from '../../services/dashboard.service';
import { LocalizationService } from '../../services/localization.service';
import { HomeObjetivosComponent } from '../home-objetivos/home-objetivos.component';
import { DashboardKPI, DashBoardModel } from '../../models/estadosGroup';
import { GlobalUIUtilsService } from '../../services/global-ui-utils.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  estadosGroup: DashBoardModel;
  incidenciasData: DashboardKPI[];
  tecnicoData: DashboardKPI;
  validadorData: DashboardKPI[];
  admin: any;
  gestor: any;

  seguimientoFacturacionList: any;

  oficinaFacturacionList: any;
  oficina: any;
  objetivosList: any;
  dataLoaded: boolean;

  _authData: AuthData;

  currentYear = new Date().getFullYear();

  constructor(public _authService: AuthService, private _dashboardService: DashboardService,
    private _router: Router, public localization: LocalizationService, private _globalui:GlobalUIUtilsService, private ref: ChangeDetectorRef) {

    this.dataLoaded = false;
  }

  ngOnInit() {
    this._authService.authDataPromise.subscribe((authData: AuthData) => {
      this._authData = authData;
      this.loadIndicadores();
    });

  }

  async loadIndicadores() {
    this._globalui.show();
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      if (this._authData.tecnico) {
        this._router.navigate(['/visitas']);
      }
    }
    this.estadosGroup = null;
    this.validadorData = null;
    this.incidenciasData = null;
    this.tecnicoData = null;


    if (this._authData.admin && this._authData.gestor) {

      this.estadosGroup = await this._dashboardService.getEstadosGroup().toPromise();

      if (this._authData.validador) {
        this.validadorData = await this._dashboardService.getValidadorData().toPromise();
      }

      this.incidenciasData = await this._dashboardService.getIncidenciasData().toPromise();

    }

    if (this._authData.tecnico) {
      this.tecnicoData = await this._dashboardService.getTecnicoData().toPromise();
    }

    if(this._authData.gestor) {
      this.estadosGroup = await this._dashboardService.getEstadosGroup().toPromise();
      this.incidenciasData = await this._dashboardService.getIncidenciasData().toPromise();
    }

    this._globalui.hide();
    this.dataLoaded = true;

    this.ref.detectChanges();


  }

}
